import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { MailPreferenceBody } from "@/pages/account/preferences/MailPreferenceBody.tsx";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";

export const MailPreference = () => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <Card id="mail-preference-card" className={styles.container}>
      <CardHeader id="mail-preference-title" title={t("pages.account.preferences.title")} />
      <CardContent>
        <MailPreferenceBody />
      </CardContent>
    </Card>
  );
};

const makeStyles = () => ({
  container: css``,
});
